import { Model, ModelClass } from './Model';

export const Sport: ModelClass = Model('Sport', {
    endpoint: 'sports',
})`
    id:Int;
    name:String;
`;
